import { Component } from '@angular/core';
import { RidButton } from '../../../components/rid-button/rid-button';
import { RidDemoPage } from '../../../components/rid-demo-page/rid-demo-page';

@Component({
  selector: 'app-phonetic-comprehension-page',
  imports: [RidDemoPage, RidButton],
  templateUrl: './phonetic-comprehension-page.html',
})
export class PhoneticComprehensionPage {}
